module.exports = __webpack_public_path__ + "img/market.5f8c131a.png";